import { UPDATE_USERINFO } from '../constants/userInfo'

export const updateUserInfo = (userInfo) => {
    return dispatch => {
        dispatch({
            type: UPDATE_USERINFO,
            userInfo
        });
    };
};